<section class="container-fluid ">
    <header class="row pt-3">
        <!-- <div class="col-12 d-flex justify-content-between">
            <div>
                <h4 class="text-white">Wizard de Proyectoooo</h4>
                <h6 class="text-secondary">Etapas para agregar anexos del proyecto</h6>
            </div>
            <div>
                <button class="me-1 btn btn-outline-light" (click)="volver()" ><i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i> Volver al listado de proyectos</button>
                <button *ngIf="step > 1"  class="mx-2 btn btn-outline-light "(click)="valor(step-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i> Volver a la etapa anterior</button>
                <button *ngIf="step < 5"  class="ms-1 btn btn-outline-light" (click)="valor(step*1+1)" > <i class="fa fa-arrow-right" aria-hidden="true"></i> Siguiente etapa</button>
            </div>           
        </div> -->

        <div class="col-12 d-flex justify-content-between ">
            <div>
                <div>
                    <h4 class="text-white">Wizard de Proyecto</h4>
                    <h6 class="text-secondary">Etapas para agregar anexos del proyecto</h6>
                </div>
            </div>
            <br>
            <div class="d-flex justify-content-center align-items-center">
              <button
                class="badge rounded-pill btn btn-outline-light "
                (click)="volver()"
              >
                <i
                  class="fa-solid fa-right-from-bracket m-2 fs-6"
                  aria-hidden="true"
                ></i>
                <span class="m-2 fs-6">Volver al listado</span>
              </button>
              
            <button
            class="badge rounded-pill btn btn-outline-light m-2 "
            *ngIf="step > 1"
            (click)="valor(step-1)"
          >
            <i
              class="fa fa-arrow-left m-2 fs-6"
              aria-hidden="true"
            ></i>
            <span class="m-2 fs-6">Etapa anterior</span>
          </button>
        
          <button
          class="badge rounded-pill btn btn-outline-light m-2"
          
          *ngIf="step < 4" 
          (click)="valor(step+1)"
        >
          <i
            class="fa fa-arrow-right m-2  fs-6"
            aria-hidden="true"
          ></i>
          <span class="m-2 fs-6">Etapa siguiente</span>
        </button>
        
          
        
            </div>
          </div>
    </header>
    
</section>
<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
    <div class="container-fluid d-flex justify-content-between align-items-center">
        <div>
            <h5 class="ms-3">{{title}}</h5>
        </div>
        <main class="row">
            <div class="col-12 d-flex justify-content-end">
              <ng-container *ngIf="permisoOptionAdmin == true">
                <button class="mx-2 btn btn-outline-light" [ngbTooltip]="'Datos'" (click)="valor(1)" [ngClass]="{'elegido':step == 1}" ><i class="fa fa-align-left mx-2" aria-hidden="true"></i></button>
                <button class="mx-2 btn btn-outline-light" [ngbTooltip]="'Etapas'" (click)="valor(2)" [ngClass]="{'elegido':step == 2}"><i class="fa fa-book mx-2" aria-hidden="true"></i></button>
              </ng-container>
              <ng-container *ngIf="permisoOptionAdminTeam == true || permisoOptionAdmin == true">
                <button class="mx-2 btn btn-outline-light" [ngbTooltip]="'Equipo'" (click)="valor(3)" [ngClass]="{'elegido':step == 3}"> <i class="fa fa-user mx-2" aria-hidden="true" ></i></button>
              </ng-container>
              <ng-container *ngIf="permisoContractAnnex == true || permisoOptionAdmin == true">  
                <button class="mx-2 btn btn-outline-light" [ngbTooltip]="'Anexos'" (click)="valor(4)" [ngClass]="{'elegido':step == 4}"><i class="fa fa-file mx-2" aria-hidden="true"></i></button>
              </ng-container>
              <ng-container *ngIf="permisoOptionAdmin == true">
                <button class="mx-2 btn btn-outline-light" [ngbTooltip]="'Configuraciones'" (click)="valor(5)" [ngClass]="{'elegido':step == 5}"><i class="fa fa-cog " aria-hidden="true"></i></button>
              </ng-container>
              </div>
        </main>
    </div>
    
    <!-- Datos -->
    <project-step-1 *ngIf="step == 1"></project-step-1>
    <!-- Etapas -->
    <project-step-2 *ngIf="step == 2"></project-step-2>
    <!-- Equipo -->
    <project-step-3 *ngIf="step == 3"></project-step-3>
    <!-- Anexos -->
    <project-step-4 *ngIf="step == 4"></project-step-4>
    <!-- Configuracion -->
    <project-step-5 *ngIf="step == 5"></project-step-5>
</section>